import Popup from "reactjs-popup";
import AddForm from "../../components/customForm/AddForm";
import ButtonComponent from "../../components/button/Button";

const AdminSectionTitle = ({title, subTitle, schema, uischema, handleSubmit, addButtonTitle, addFormTitle, addFormSubtitle}) => {
    
    return (
      <div className="py-5 flex justify-between items-center border-[1px] border-color-primary-dark2 rounded-md my-10 px-10">
        <div>
          <div className="font-bold uppercase">{title}</div>
          <div>{subTitle}</div>
        </div>
        <div>
          <div className="">
            <Popup
              trigger={
                <div>
                  <ButtonComponent
                    name={addButtonTitle}
                    disabled={false}
                    type={"add"}
                  />
                </div>
              }
              position="left top"
              contentStyle={{
                borderRadius: 10,
                overflow: "auto",
                maxHeight: "90%",
                minWidth: "60%",
              }}
              // open={openPopup}
            >
              {(close) => (
                <AddForm
                  title={addFormTitle}
                  subtitle={addFormSubtitle}
                  close={close}
                  schema={schema}
                  uischema={uischema}
                  initialData={{}}
                  handleSubmit={handleSubmit}
                />
              )}
            </Popup>
          </div>
        </div>
      </div>
    );
}

export default AdminSectionTitle;